<template>
  <div id="footer">
    <div id="upper-footer">
      <img height="100%" id="header-logo" src="../assets/img/logo.png"/>
    </div>
    <div id="lower-footer">
      <div>
        {{ getCurrentTimeMoment.year() }} Bork Horeca - powered by <a href="https://www.motivate.nl" target="_blank">Motivate</a>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'Footer',
  data() {
    return {
    };
  },
  created() {
    // Keep updating the time and date
  },
  computed: {
    ...mapGetters(['getCurrentTimeMoment'])
  }
};
</script>
<style lang="scss">
@import "./../assets/scss/main.scss";

$lowerPartHeight: 4rem;

#footer {
  height: $footerHeight;
  background-color: #757575;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr $lowerPartHeight;
  grid-column-gap: 0px;
  grid-row-gap: 0px;
}

#upper-footer {
  display: grid;
  padding-left: 2rem;
  padding-right: 2rem;
  align-items: center;
  height: 100%;
}

#header-logo {
  height: calc(#{$footerHeight} - #{$lowerPartHeight});
}

#lower-footer {
  display: grid;
  padding-left: 2rem;
  padding-right: 2rem;
  align-items: center;
  height: 100%;
  background-color: #212121;
}
</style>
